import { createSlice } from '@reduxjs/toolkit'
import { getMachines, saveMachine, createMachine, deleteMachine } from './machineActions'

const initialState = {
  machines: [],
  loading: false,
  loadingError: false,
  loaded: false,
  saving: false,
  savingError: false,
  saved: false,
  savedMachine: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

/*function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}*/

const machinesSlice = createSlice({
  name: 'machines',
  initialState,
  reducers: {
    clear: (state) => {
      state.loading = false
      state.loadingError = false
      state.loaded = false

      state.saving = false
      state.savingError = false
      state.saved = false
      state.savedMachine = {}

      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getMachines.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loaded = true
        state.loadingError = null
        state.machines = payload
      })
      .addCase(getMachines.pending, (state) => {
        state.loading = true
        state.loaded = false
        state.loadingError = null
      })
      .addCase(getMachines.rejected, (state, { payload }) => {
        state.loading = false
        state.loaded = false
        state.loadingError = payload
      })
      .addCase(saveMachine.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveMachine.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.machines[state.machines.findIndex((p) => p.id === payload.id)] = payload
        state.savedMachine = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveMachine.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createMachine.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createMachine.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedMachine = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createMachine.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteMachine.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteMachine.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteMachine.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
  },
})

export const { clear } = machinesSlice.actions
export default machinesSlice.reducer
